import type { ZodType } from "zod";
import z from "zod";

import type { JsonValue } from "./document.js";

/** One answer as a reader gets it back. A comment is an answer of its own. */
export type AssessmentResponseUnbranded = {
  group: string;
  item: string;
  response: JsonValue;
};

export const AssessmentResponseSchema = z.object({
  group: z.string(),
  item: z.string(),
  response: z.custom<JsonValue>(),
}) satisfies ZodType<AssessmentResponseUnbranded>;
